import { schema } from 'normalizr'

export const reportSchema = new schema.Entity(
  'reports',
  {},
  {
    idAttribute: 'id',
  }
)
